import type { AddressProto } from "@noom/noom-contracts/noom_contracts/billing/address/address";
import { invalidateBillingUserQuery } from "src/hooks/checkout/billingUser";
import {
  clearBillingUserHomeAddressRequest,
  getAddressRequest,
  getBillingUserRequest,
} from "src/utils/api/purchase/ordersCheckoutApi";
import { isNotFoundError } from "src/utils/fetch";
import normalizePostalCode from "src/utils/normalizePostalCode";
import type { BillingDataState } from "src/utils/redux/slices/billingData";
import { isRequestSuccess } from "src/utils/redux/requestState";

export function hasBillingActiveSubscription(
  billingData?: Pick<BillingDataState, "activeSubscription">
): boolean {
  const activeSubscription = billingData?.activeSubscription;
  return (
    isRequestSuccess(activeSubscription) && activeSubscription.data != null
  );
}

export function getSurveyZipcodeFromHomeAddress(
  homeAddress?: AddressProto | null | undefined
): string | null {
  if (!homeAddress?.postalCode?.trim()) {
    return null;
  }

  const surveyZipcode = normalizePostalCode(homeAddress.postalCode);
  return surveyZipcode || null;
}

export async function clearStaleBillingHomeAddressId(
  accessCode: string
): Promise<void> {
  await clearBillingUserHomeAddressRequest(accessCode);
  invalidateBillingUserQuery();
}

export async function fetchBillingUserHomeAddress(
  accessCode: string
): Promise<AddressProto | null> {
  const billingUser = await getBillingUserRequest(accessCode);

  if (!billingUser.homeAddressId) {
    return null;
  }

  try {
    return await getAddressRequest(accessCode, billingUser.homeAddressId);
  } catch (error) {
    if (isNotFoundError(error)) {
      await clearStaleBillingHomeAddressId(accessCode);
      return null;
    }
    throw error;
  }
}
